export default "__VITE_ASSET__1a0224b2__"